import { Button, ButtonSize, ButtonVariant, Text, TextVariants } from "@next-platform/client-common-spicy-ui";

import Trans from "@/components/Trans/Trans";

type GalleryLoadErrorProps = {
  testId: string;
  onRetry: () => void;
};

// Shown when a batch fails: under the tiles that are already on screen, or alone when the first page failed.
const GalleryLoadError = ({ testId, onRetry }: GalleryLoadErrorProps) => {
  return (
    <div data-testid={testId} role="alert" className="flex flex-col items-center gap-3 px-4 py-6">
      <Text className="text-center text-gray-11" variant={TextVariants.LABEL_MEDIUM_REGULAR}>
        <Trans i18nKey="gallery:loadError.message" />
      </Text>
      <Button variant={ButtonVariant.OUTLINED} size={ButtonSize.MEDIUM} onClick={onRetry} data-testid={`${testId}-RetryButton`}>
        <Trans i18nKey="common:retry" />
      </Button>
    </div>
  );
};

export default GalleryLoadError;
